module.exports = __webpack_public_path__ + "img/page8-bg.25d3fd93.png";